module.exports = __webpack_public_path__ + "static/media/main_slider_1.0dd2d81a.jpg";